(function () {
  function initOMaxFaq(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-o-max-faq]');

    sections.forEach(function (section) {
      if (!section || section.dataset.faqReady === 'true') return;

      const items = Array.from(section.querySelectorAll('.om-faq__item'));
      if (!items.length) return;

      section.dataset.faqReady = 'true';

      function closeOthers(currentItem) {
        items.forEach(function (item) {
          if (item !== currentItem) {
            item.removeAttribute('open');
          }
        });
      }

      const firstOpenItem = items.find(function (item) {
        return item.open;
      });

      if (firstOpenItem) {
        closeOthers(firstOpenItem);
      }

      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) {
            closeOthers(item);
          }
        });
      });

      document.addEventListener('shopify:block:select', function (event) {
        const block = event.target.closest('.om-faq__item');
        if (!block || !section.contains(block)) return;

        closeOthers(block);
        block.setAttribute('open', '');
        block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initOMaxFaq(document);
    });
  } else {
    initOMaxFaq(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initOMaxFaq(event.target);
  });
})();